import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy
} from "@angular/core";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { UntypedFormControl } from "@angular/forms";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import {
  MatAutocomplete,
  MatAutocompleteSelectedEvent,
} from "@angular/material/autocomplete";
import { MatChipInputEvent } from "@angular/material/chips";
import { LorenAsset } from "../../../../features/loren-assets/interfaces/loren-asset.interface";

@Component({
    selector: "loren-asset-selection",
    templateUrl: "./loren-asset-selection.component.html",
    styleUrls: ["./loren-asset-selection.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LorenAssetSelectionComponent implements OnInit {
  @Input() allAssets: LorenAsset[] = [];
  @Input() selectedAssets: LorenAsset[] = [];
  @Output() changedAssetSelection = new EventEmitter<LorenAsset[]>();

  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  assetCtrl = new UntypedFormControl();
  filteredAssets: Observable<LorenAsset[]>;
  assets: string[] = [];

  @ViewChild("assetInput") assetInput: ElementRef<HTMLInputElement>;
  @ViewChild("auto") matAutocomplete: MatAutocomplete;

  constructor() {
    this.filteredAssets = this.assetCtrl.valueChanges.pipe(
      startWith(null),
      map((asset: string | null) => {
        return this._filter(asset);
      })
    );
  }

  ngOnInit(): void {
    this.assets = this.selectedAssets.map((x) => x.name);
  }

  add(event: MatChipInputEvent): void {
    const input = event.chipInput;
    const value = event.value;

    // Add our fruit
    if ((value || "").trim()) {
      this.assets.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.inputElement.value = "";
    }

    this.assetCtrl.setValue(null);
  }

  remove(asset: string): void {
    const index = this.assets.indexOf(asset);

    if (index >= 0) {
      this.assets.splice(index, 1);
    }

    this.selectedAssets.splice(
      this.selectedAssets.findIndex((x) => x.name === asset),
      1
    );
    this.changedAssetSelection.emit(this.selectedAssets);
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.assets.push(event.option.viewValue);
    const selectedAsset = this.allAssets.find(
      (x) => x.name === event.option.viewValue
    );
    if (selectedAsset) {
      this.selectedAssets.push(selectedAsset);
      this.changedAssetSelection.emit(this.selectedAssets);
    }

    this.assetInput.nativeElement.value = "";
    this.assetCtrl.setValue(null);
    this.assetInput.nativeElement.blur();
    setTimeout(() => this.assetInput.nativeElement.focus(), 5);
  }

  private _filter(value: string): LorenAsset[] {
    const withoutAlreadySelected = this.allAssets.filter(
      (asset) => !this.assets.includes(asset.name)
    );

    if (!value) {
      return withoutAlreadySelected;
    }

    return withoutAlreadySelected.filter((asset) =>
      asset.name.toLowerCase().includes(value.toLowerCase())
    );
  }
}
